<template>
  <div class="ad-manage">
    <!-- 筛选查询 -->
    <el-card class="filter-card">
      <app-filter
        :filter-list="table_filter"
        @search="searchTable"
      />
    </el-card>

    <!-- 项目报表折线图 -->
    <div v-if="is_exist_search">
      <el-card
        v-for="(line_item, key) in line_config"
        :key="key"
        v-loading="is_loading"
        class="box-card"
      >
        <div>
          <label>{{ line_item.label }}：</label>
          <el-select
            v-model="line_item.value"
            size="mini"
            :placeholder="'请选择' + line_item.label"
            @change="updateLine(key, line_item.value)"
          >
            <el-option
              v-for="(item, index) in line_item.options"
              :key="index"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </div>
        <base-line
          ref="lineDom"
          v-loading="line_item.is_loading"
          style="width: 100%; height: 500px"
          v-bind="line_item.config"
        />
      </el-card>
    </div>

    <!-- 项目报表列表 -->
    <el-card v-loading="is_loading" class="show-table-card">
      <div>
        <label>{{ show_table_data.label }}：</label>
        <el-select
          v-model="show_table_data.value"
          size="mini"
          multiple
          filterable
          style="width: 100%; margin-top: 15px;"
          :placeholder="'请选择' + show_table_data.label"
          @change="onFieldsChange"
        >
          <el-option
            v-for="(item, index) in show_table_data.options"
            :key="index"
            :disabled="item.disabled"
            :label="item.name"
            :value="item"
          />
        </el-select>
      </div>
      <app-table
        ref="report_table"
        style="margin-top: 15px;"
        :table-key="[
          ...table_key,
          ...show_table_data.value
        ]"
        :tablep="table_params"
        :get-data="getProjectList"
        :is-request="false"
      />
    </el-card>
  </div>
</template>

<script>
import {
  getProjectConvertReportApi,
  getProjectPlatformReportApi,
  getProjectTableReportApi,
} from '@/api/report/jrtt/project';

import { getMediasListApi } from '@/api/medias';

import { getProjectSelectorApi } from '@/api/project/jrtt';
import { getLineChart } from './model/line-chart-config';
import { BaseLine } from '@/components/re-echart';
import { clone } from '@/utils';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    BaseLine,
  },
  data() {
    return {
      table_filter: require('./model/table-filter')(this),

      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
      },

      // 是否加载
      is_loading: false,

      // 项目筛选框
      project_ids: {
        options: [],
        value: [],
      },

      /** 表格数据 */
      table_list_data: {
        list: [{
          id: 1,
        }],
      },

      /**
       * 项目配置
       */
      project_config: {
        is_show: false,
        title: '创建项目',
        data: {},
      },

      /**
       * 线形图配置
       */
      line_config: {
        convert: {
          label: '转化目标',
          is_loading: false,
          options: require('./model/field-config')(this).filter(item => !item.disabled),
          value: '',
          config: {
            lineData: [],
            xAxis: {
              data: [],
            },
            yAxis: {
              type: 'value',
              data: [],
            },
          },
        },
        platform: {
          label: '平台',
          is_loading: false,
          options: require('./model/field-config')(this).filter(item => !item.disabled),
          value: '',
          config: {
            lineData: [],
            xAxis: {
              data: [],
            },
            yAxis: {
              type: 'value',
              data: [],
            },
          },
        },
      },
      // 显示表格数据
      show_table_data: {
        label: '显示表格数据',
        options: require('./model/field-config')(this),
        value: require('./model/field-config')(this),
      },
      table_key: require('./model/table-key')(this),
    };
  },
  computed: {
    /** 是否存在查询参数 */
    is_exist_search(){
      return !isEmpty(this.getPostData());
    },
  },
  created(){
    this.getMediasList();

    const { advertiser_id, project_id } = this.$route.query;
    if (advertiser_id) {
      this.table_filter.advertiser_ids.value = [Number(advertiser_id)];
    }

    if (project_id) {
      this.table_filter.project_ids.value = [project_id];
      this.getProjectSelector();
    }
  },
  methods: {
    /**
     * 查询表格
     * @param {*} params_value
     */
    searchTable(params_value) {
      const { date } = params_value;
      if (date?.length) {
        params_value['start_date'] = date[0];
        params_value['end_date'] = date[1];
        delete params_value.date;
      }

      this.table_params = {
        ...this.table_params,
        ...params_value,
        'fields': this.show_table_data.value.map(item => item.value),
      };

      // 转化目标图表选中指标
      if (this.line_config.convert.value) {
        this.updateLine('convert');
      }

      // 平台图表选中指标
      if (this.line_config.platform.value) {
        this.updateLine('platform');
      }

      this.$nextTick(() => {
        this.$refs.report_table.seekTable();
      });
    },

    /**
     * 修改项目
     * @param { Object } row 行数据
     */
    editAd(row) {
      this.project_config.is_show = true;
      this.project_config.data = row;
    },

    /**
     * 项目表单取消
     */
    adFormCancel() {
      if (this.project_config.data) {
        this.project_config.data = null;
      }

      this.project_config.is_show = false;
    },

    /**
     * 项目表单确定
     */
    adFormConfirm() {
      this.adFormCancel();
    },

    /** 获取广告账号列表 */
    getMediasList() {
      return getMediasListApi({
        type: 'jrtt',
        is_list: true,
      }).then((res) => {
        this.table_filter.advertiser_ids.options = res.list.map((accoun_item) => {
          return {
            label: `${accoun_item.advertiser_id}(${accoun_item.advertiser_name})${accoun_item.note ? ' - ' + accoun_item.note : ''}`,
            value: accoun_item.advertiser_id,
          };
        });
      });
    },

    /** 获取项目选择器列表 */
    getProjectSelector() {
      if (this.table_filter.advertiser_ids?.value) {
        return getProjectSelectorApi({
          advertiser_ids: this.table_filter.advertiser_ids.value,
        }).then((res) => {
          this.table_filter.project_ids.options = res.list.map((item) => {
            return {
              label: item.name,
              value: item.type_id,
            };
          });
        });
      }
    },

    /** 获取项目列表 */
    getProjectList(params) {
      return new Promise((resolve, reject) => {
        /** 不存在查询参数时直接reject并终止代码执行 */
        if (!this.is_exist_search) {
          reject();
          return;
        }
        getProjectTableReportApi(params).then(resolve).catch(reject);
      });
    },

    /**
     * 更新折线图
     * @param {string} key 键值
     */
    updateLine(key) {
      switch (key) {
        case 'convert':
          this.getConvertReport();
          break;
        case 'platform':
          this.getPlatformReport();
          break;
      }
    },

    /**
     * 获取转化报表
     */
    getConvertReport() {
      let options_data = [];
      this.line_config.convert.is_loading = true;
      getProjectConvertReportApi({
        ...this.getPostData(),
        external_actions: this.$store.getters.jrttEnum.api_2_ad_convert_type.map(item => item.value),
        field: this.line_config.convert.value,
      }).then((res) => {
        options_data = res.list;
        this.line_config.convert.config.lineData = res.list.map(item => item[1]);
        const convert_line_config = getLineChart(options_data, this.$store.getters.jrttEnum.api_2_ad_convert_type);
        this.$refs.lineDom[0].init(convert_line_config);
      }).finally(() => {
        this.line_config.convert.is_loading = false;
      });
    },

    /**
     * 获取平台报表
     */
    getPlatformReport() {
      let options_data = [];
      this.line_config.platform.is_loading = true;
      getProjectPlatformReportApi({
        ...this.getPostData(),
        platforms: this.$store.getters.jrttEnum.api_2_platforms.map(item => item.value),
        field: this.line_config.platform.value,
      }).then((res) => {
        options_data = res.list;
        const platform_line_config = getLineChart(options_data, this.$store.getters.jrttEnum.api_2_platforms);
        this.line_config.platform.config.lineData = [''];
        this.$refs.lineDom[1].init(platform_line_config);
      }).finally(() => {
        this.line_config.platform.is_loading = false;
      });
    },

    /** 监听指标改变 */
    onFieldsChange() {
      Object.assign(this.table_params, { 'fields': this.show_table_data.value.map(item => item.value) });
    },

    /** 获取图表查询所需参数 */
    getPostData() {
      const post_data = clone(this.table_params);
      delete post_data.page;
      delete post_data.limit;
      delete post_data.fields;
      return post_data;
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-manage {
  .func-box {
    .el-button {
      margin-left: 10px;
    }
  }
}
/deep/ .el-card {
    margin-bottom: 20px;
}
</style>
